import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getBiDataForTierLink } from '../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import TierPromotionCard from '../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../TierPromotionCardWithFellaTooltip';
import { ViewerContainerSizeContext } from '../../../DaEditorWrapper/ViewerContainerSizeContext/ViewerContainerSizeContext';
import s from './Tier.scss';
const TierFeedCardContents = ({ deviation, width, className, showTierPromotionTooltip })=>{
    // TODO: refactor this away
    const layoutWidth = useContext(ViewerContainerSizeContext);
    const biData = getBiDataForTierLink(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, showTierPromotionTooltip ? /*#__PURE__*/ React.createElement(TierPromotionCardWithFellaTooltip, {
        deviation: deviation,
        width: width !== null && width !== void 0 ? width : layoutWidth,
        isPostsFeedCard: true
    }) : /*#__PURE__*/ React.createElement(TierPromotionCard, {
        deviation: deviation,
        width: width !== null && width !== void 0 ? width : layoutWidth
    }), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['link-overlay'],
        biData: biData,
        href: Url.userSubscriptionsPath({
            username: deviation.author.username,
            tierDeviationId: deviation.deviationId,
            tierContentType: 'deviations'
        })
    }, /*#__PURE__*/ React.createElement("span", null)));
};
TierFeedCardContents.displayName = 'TierFeedCardContents';
export default TierFeedCardContents;

//# sourceMappingURL=Tier.js.map